import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { 
  FaHome, FaCar, FaTicketAlt, FaUsers, 
  FaCog, FaCalendarAlt, FaMoneyBillWave, 
  FaMapMarkerAlt, FaBed, FaPauseCircle, 
  FaCalendarPlus, FaPercentage
} from 'react-icons/fa';

const Sidebar = () => {
  const location = useLocation();

  return (
    <Nav className="flex-column sidebar">
      <div className="sidebar-header">
        <h4>Admin Panel</h4>
      </div>
      
      <Nav.Item>
        <Nav.Link 
          as={Link} 
          to="/admin/dashboard" 
          active={location.pathname === '/admin/dashboard'}
          className="sidebar-link"
        >
          <FaHome className="sidebar-icon" /> Dashboard
        </Nav.Link>
      </Nav.Item>
      
      <Nav.Item>
        <Nav.Link 
          as={Link} 
          to="/admin/bookings" 
          active={location.pathname.startsWith('/admin/bookings')}
          className="sidebar-link"
        >
          <FaCalendarAlt className="sidebar-icon" /> Bookings
        </Nav.Link>
      </Nav.Item>
      
      <Nav.Item>
        <Nav.Link 
          as={Link} 
          to="/admin/vehicles" 
          active={location.pathname.startsWith('/admin/vehicles')}
          className="sidebar-link"
        >
          <FaCar className="sidebar-icon" /> Vehicles
        </Nav.Link>
      </Nav.Item>
      
      <Nav.Item>
        <Nav.Link 
          as={Link} 
          to="/admin/coupons" 
          active={location.pathname.startsWith('/admin/coupons')}
          className="sidebar-link"
        >
          <FaTicketAlt className="sidebar-icon" /> Coupons
        </Nav.Link>
      </Nav.Item>
      
	  
	  <Nav.Item>
  <Nav.Link as={Link} to="/admin/drivers"
  active={location.pathname.startsWith('/admin/drivers')}
          className="sidebar-link">

    Drivers
  </Nav.Link>
</Nav.Item>
	  
	  
      <Nav.Item>
        <Nav.Link 
          as={Link} 
          to="/admin/users" 
          active={location.pathname.startsWith('/admin/users')}
          className="sidebar-link"
        >
          <FaUsers className="sidebar-icon" /> Users
        </Nav.Link>
      </Nav.Item>
      
      <div className="sidebar-section-header">
        <span>System Settings</span>
      </div>
      
      <Nav.Item>
        <Nav.Link 
          as={Link} 
          to="/admin/settings/stop-fees" 
          active={location.pathname === '/admin/settings/stop-fees'}
          className="sidebar-link"
        >
          <FaMoneyBillWave className="sidebar-icon" /> Stop Fees
        </Nav.Link>
      </Nav.Item>
      
	  
	  
	  <Nav.Item>
  <Nav.Link as={Link} to="/admin/settings/events"
  active={location.pathname.startsWith('/admin/settings/events')}
          className="sidebar-link">

    Events
  </Nav.Link>
</Nav.Item>
	  
	  
	  
	  
	  
	  
	  
	  
	  
	  
      <Nav.Item>
        <Nav.Link 
          as={Link} 
          to="/admin/settings/prior-booking" 
          active={location.pathname === '/admin/settings/prior-booking'}
          className="sidebar-link"
        >
          <FaCalendarPlus className="sidebar-icon" /> Prior Booking
        </Nav.Link>
      </Nav.Item>
      
      <Nav.Item>
        <Nav.Link 
          as={Link} 
          to="/admin/settings/zones" 
          active={location.pathname === '/admin/settings/zones'}
          className="sidebar-link"
        >
          <FaMapMarkerAlt className="sidebar-icon" /> Zones
        </Nav.Link>
      </Nav.Item>
      
      <Nav.Item>
        <Nav.Link 
          as={Link} 
          to="/admin/settings/addons" 
          active={location.pathname === '/admin/settings/addons'}
          className="sidebar-link"
        >
          <FaCog className="sidebar-icon" /> Addons
        </Nav.Link>
      </Nav.Item>
      
      <Nav.Item>
        <Nav.Link 
          as={Link} 
          to="/admin/settings/late-night-charges" 
          active={location.pathname === '/admin/settings/late-night-charges'}
          className="sidebar-link"
        >
          <FaBed className="sidebar-icon" /> Late Night Charges
        </Nav.Link>
      </Nav.Item>
      
      <Nav.Item>
        <Nav.Link 
          as={Link} 
          to="/admin/settings/pause-dates" 
          active={location.pathname === '/admin/settings/pause-dates'}
          className="sidebar-link"
        >
          <FaPauseCircle className="sidebar-icon" /> Pause Dates
        </Nav.Link>
      </Nav.Item>
      
      <Nav.Item>
        <Nav.Link 
          as={Link} 
          to="/admin/settings/overcharge-locations" 
          active={location.pathname === '/admin/settings/overcharge-locations'}
          className="sidebar-link"
        >
          <FaPercentage className="sidebar-icon" /> Overcharge Locations
        </Nav.Link>
      </Nav.Item>
	  
	  
	  
	  
	  
	  
<Nav.Item>
  <Nav.Link as={Link} to="/admin/settings/admin-management">
    Admin Management
  </Nav.Link>
</Nav.Item>	  
	  
	  
      
      <div className="sidebar-footer">
        <button 
          onClick={() => {
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminRole');
            window.location.href = '/admin/login';
          }} 
          className="btn btn-danger btn-sm"
        >
          Logout
        </button>
      </div>
    </Nav>
  );
};

export default Sidebar;